import OnboardingDepositCashScreen from 'features/onboarding/screens/OnboardingDepositCash/OnboardingDepositCashScreen';
import React from 'react';

export default function OnboardingDepositCash() {
  return <OnboardingDepositCashScreen />;
}
